import { Profile } from '@/components/HankoAuth';

const ProfilePage: React.FC = () => {
  return (
    <>
      <div className="grid grid-cols-2 py-8-0 gap-2-0">
        <div className="p-2-0 rounded-8-0 shadow">
          <Profile />
        </div>

        <div className="p-2-0 rounded-8-0 shadow">
          {/* <ProfileAddresses /> */}
        </div>
      </div>
    </>
  );
};

export default ProfilePage;
